'use strict';

import '@fancyapps/fancybox';
import cf7Helpers from '../../../src/js/shared/cf7Helpers';

const $ = jQuery.noConflict();
$(function() {

	const ctaGroup = {

		init: function() {
			this.cacheDOM();
			this.bindEvents();
			cf7Helpers.afterFormSubmit();
			cf7Helpers.preventNumTelInputsTypeLetters();
		},

		cacheDOM: function() {
			this.$shareBtn = $('.js-cta-share-btn');
			this.$popup = $('.js-cta-popup');
		},

		bindEvents: function() {
			this.$shareBtn.on('click', () => {
				$.fancybox.open({
					src: this.$popup,
					type: 'inline',
					smallBtn: true,
					baseClass: 'cta-group-popup',
				});
			});
		},

	};

	if ($('.js-cta-share-btn').length) {
		ctaGroup.init();
	}
});
